import React from "react";
import { BaseDesignElement } from "@design-controls/types";
import { elementStatus, ElementStatusTag } from "../../domain/elementStatus";
import { QTag } from "@qualio/ui-components";

const ORDER = [
  "Declined",
  "New",
  "Changed",
  "Deleted",
  "In review",
  "Approved",
] as const;

export function designElementStatusColumn<
  T extends Pick<BaseDesignElement, "itemStatus" | "changeControlStatus">,
>(): any {
  return {
    id: "status",
    accessorFn: elementStatus,
    header: "Status",
    meta: {
      maxWidth: "200px",
    },
    cell: ({ row: { original: row } }: { row: { original: T } }) => (
      <QTag variantColor={ElementStatusTag[elementStatus(row)]}>
        {elementStatus(row)}
      </QTag>
    ),
    sortingFn: (a: any, b: any, columnId: string) => {
      const aVal = a.getValue(columnId) as string;
      const bVal = b.getValue(columnId) as string;

      return (
        ORDER.findIndex((a) => a === aVal) - ORDER.findIndex((b) => b === bVal)
      );
    },
    enableSorting: true,
  };
}
